import * as React from 'react';
import { useState } from 'react';
import EditContactNumberModal from '../../../components/bookings/modals/EditContactNumberModal';
import ErrorModal from '../../../components/common/ErrorModal';
import LoadingModal from '../../../components/common/LoadingModal';
import { Booking } from '../../../models/bookings/Booking';
import { HttpErrorResponse } from '../../../models/common/HttpErrorResponse';
import { apiPatch } from '../../../services/api';
import { getErrorMessage } from '../../../helpers/errors';

interface EditContactNumberModalContainerProps {
    booking: Booking;
    showModal: boolean;
    onSave?(): void;
    onClose(): void;
}

const EditContactNumberModalContainer: React.FC<EditContactNumberModalContainerProps> = ({
    booking,
    showModal,
    onSave,
    onClose
}) => {
    const [updatingContactNumber, setUpdatingContactNumber] = useState(false);
    const [error, setError] = useState<HttpErrorResponse>();

    const handleSaveClicked = async (contactNumber: string | null) => {
        if (booking.contactNumber !== contactNumber) {
            setUpdatingContactNumber(true);
            try {
                await apiPatch(`Booking/${booking.id}/ContactNumber`, {
                    contactNumber: contactNumber
                });
            } catch (e) {
                console.warn(e);
                setUpdatingContactNumber(false);
                setError(e as HttpErrorResponse);
            }
            if (onSave) {
                onSave();
            }
        }
    };

    const handleEditContactNumberModalClose = () => {
        if (updatingContactNumber) {
            return;
        }
        onClose();
    };

    const modalHeader = `Edit contact number: ${booking.reference}`;
    const showLoadingModal = updatingContactNumber && !error;
    const showEditContactNumberModal = !updatingContactNumber && !error;

    return (
        <>
            <LoadingModal
                showModal={showModal && showLoadingModal}
                header={modalHeader}
                loadingText={
                    updatingContactNumber
                        ? 'Updating contact number...'
                        : 'Loading...'
                }
            />
            <EditContactNumberModal
                booking={booking}
                showModal={showModal && showEditContactNumberModal}
                onSave={handleSaveClicked}
                onClose={handleEditContactNumberModalClose}
            />
            {error && (
                <ErrorModal
                    showModal={showModal && !!error}
                    header={modalHeader}
                    errorText={`An error has occurred when updating the contact number: ${getErrorMessage(
                        error
                    )}`}
                    onClose={handleEditContactNumberModalClose}
                />
            )}
        </>
    );
};

export default EditContactNumberModalContainer;
